import { useState, useEffect, Fragment, useCallback } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import {
  ResponseSuccessModal,
  ResponseFailModal,
} from "../../components/Modal/Response";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../stores";
import TermTemplatesDelete from "../../components/TermsTemplates/TermTemplatesDelete";
import {
  changeResult,
  deleteTermTemplatesAction,
  initialize,
} from "../../stores/termsTemplates";
import { TermTemplatesDeleteContainerProps } from "../../types/termTemplates";

const TermTemplatesDeleteContainer = ({
  isOpen,
  toggle,
  reload,
  id,
  termTemplatesListName,
}: TermTemplatesDeleteContainerProps) => {
  const dispatch = useDispatch();
  const { termTemplatesDeleteSuccess, termTemplatesDeleteError } = useSelector(
    ({ termTemplates }: RootState) => ({
      termTemplatesDeleteSuccess: termTemplates.termTemplatesDeleteSuccess,
      termTemplatesDeleteError: termTemplates.termTemplatesDeleteError,
    }),
  );
  const [
    isOpenTermTemplatesDeleteSuccessModal,
    setIsOpenTermTemplatesDeleteSuccessModal,
  ] = useState<boolean>(false);
  const [
    isOpenTermTemplatesDeleteFailModal,
    setIsOpenTermTemplatesDeleteFailModal,
  ] = useState<boolean>(false);
  const [messageTermTemplatesDeleteFail, setMessageTermTemplatesDeleteFail] =
    useState<string>("");

  const handleDeleteTermTemplates = useCallback(() => {
    dispatch(deleteTermTemplatesAction({ id }));
  }, [id, dispatch]);

  useEffect(() => {
    if (termTemplatesDeleteError) {
      toggle();
      if (!termTemplatesDeleteError.response) {
        setMessageTermTemplatesDeleteFail(termTemplatesDeleteError.message);
        setIsOpenTermTemplatesDeleteFailModal(true);
      } else {
        if (termTemplatesDeleteError.response.data === undefined) {
          setMessageTermTemplatesDeleteFail(termTemplatesDeleteError.message);
        } else {
          setMessageTermTemplatesDeleteFail(
            `${termTemplatesDeleteError.response.data.code}, ${termTemplatesDeleteError.response.data.message}`,
          );
          if (
            termTemplatesDeleteError.response.data?.code === 401 ||
            termTemplatesDeleteError.response.data?.code === 419
          )
            reload();
        }
        setIsOpenTermTemplatesDeleteFailModal(true);
      }
      dispatch(
        changeResult({
          key: "blackDeleteError",
          value: null,
        }),
      );
      return;
    }
    if (termTemplatesDeleteSuccess) {
      toggle();
      setIsOpenTermTemplatesDeleteSuccessModal(true);
      setTimeout(() => {
        setIsOpenTermTemplatesDeleteSuccessModal(false);
        reload();
      }, 1500);
      dispatch(initialize()); //hotel.ts 전역상태 초기화
    }
  }, [
    dispatch,
    termTemplatesDeleteError,
    termTemplatesDeleteSuccess,
    reload,
    toggle,
  ]);

  return (
    <Fragment>
      <Modal show={isOpen} onHide={() => toggle()} centered size="sm">
        <ModalBody className="text-center m-3">
          <TermTemplatesDelete
            termTemplatesName={termTemplatesListName}
            toggle={toggle}
            handleDeleteTermTemplates={handleDeleteTermTemplates}
          />
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenTermTemplatesDeleteSuccessModal}
        toggle={() =>
          setIsOpenTermTemplatesDeleteSuccessModal(
            !isOpenTermTemplatesDeleteSuccessModal,
          )
        }
        message="약관 삭제가 완료 되었습니다."
      />
      <ResponseFailModal
        isOpen={isOpenTermTemplatesDeleteFailModal}
        toggle={() =>
          setIsOpenTermTemplatesDeleteFailModal(
            !isOpenTermTemplatesDeleteFailModal,
          )
        }
        message={
          messageTermTemplatesDeleteFail || "약관 삭제에 실패 하였습니다."
        }
      />
    </Fragment>
  );
};

export default TermTemplatesDeleteContainer;
